export enum ROLES {
  USER = "USER",
  ADMIN = "ADMIN",
}
